export default __webpack_public_path__ + "static/registro_de_datos-d6258ffe72c2b5a6acdaff45cfced17a.mp4";